import * as angular from 'angular';

import { AlarmEmailDTO } from '../../models/';
import { IAlarmEmailActionsService } from './alarmEmail.actionCreator';
import { IDispatcherService, IDispatcher } from '../';

export interface IAlarmEmailStoreService {
    getOne: (guid: string) => angular.IPromise<AlarmEmailDTO>;
    getAll: (force?: boolean) => angular.IPromise<AlarmEmailDTO[]>;
}

export interface IAlarmEmailActionDispatcherService extends IDispatcherService<IAlarmEmailStoreService> { }

export class AlarmEmailActionDispatcherService implements IAlarmEmailActionDispatcherService {
    static serviceId = 'alarmEmailActionDispatcherService';

    static $inject = ['alarmEmailActionsService'];

    constructor(private _actionService: IAlarmEmailActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IAlarmEmailStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) =>  dispatch(actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
            }
        };
    }
}